import sni from '../slices/sni';
import type { RootStateType, ThunkDispatchType } from '../index';

import { getAll as getSettable } from '../../api-admin/sni';

export function fetchSettableSniIndustries() {
    return async (dispatch: ThunkDispatchType) => {
        try {
            dispatch(sni.actions.fetch());
            const data = await getSettable();
            dispatch(sni.actions.fetched({ data }));
        } catch (e) {
            console.log('ERROR fetching SNI industries, set redux error state and handle in errorBoundary.', e);
            dispatch(sni.actions.fetched({ data: [] }));
        }
    };
}

export const selectSettableSniIndustries = () => (state: RootStateType) => state.sni.all;
export const selectFetchingSettableSniIndustries = () => (state: RootStateType) => state.sni.fetching;
